










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Tile extends Vue {
  @Prop() private msg!: string;
  @Prop() private color!: string;
}
